<template>
  <div>
    <b-breadcrumb :items="breadcrumbs"></b-breadcrumb>
    <h2 class="mb-1">{{$t('annual-certifications.title')}}</h2>

    <AppLoader v-if="isLoading" class="text-center" small />
    <b-row class="ml-2 mt-2 mr-2" style="height: calc(100vh - 200px); overflow:auto;">
      <b-col cols="3" v-for="(certificate,index) in certifications" :key="index">
        <b-card bg-variant="default" class="mb-2" style="height:300px;">
          <b-card-text class="my-3">
            <font-awesome-icon icon="file-signature" size="5x" style="color:#3DDC97;" />
          </b-card-text>
          <!-- <b-card-text>{{questionnaire.task_title}}</b-card-text> -->
          <b-card-text class="mb-1">{{getFormTitle(certificate)}}</b-card-text>
          <b-card-text
            class="mb-0 text-capitalize"
            v-if="certificate.comp_name_eng &&  certificate.country"
          >({{certificate.comp_name_eng}} - {{certificate.country}})</b-card-text>
          <b-card-text class="mb-2">
            <span :class="'badge badge-' + getQuestionnaireStatusVariant(certificate.task_status)">{{ getQuestionnaireStatusText(certificate.task_status) }}</span>
          </b-card-text>

          <b-button
            v-if="certificate.task_status != 4"
            class="mr-2"
            variant="outline-primary"
            @click="getTaskForm(certificate.form_id,certificate.type,certificate.id,certificate.task_title)"
          >{{getQuestionnaireButtonLabel(certificate.task_status)}}</b-button>

          <b-button
            v-if="certificate.task_status == 4"
            variant="outline-dark"
            @click="downloadPdf(certificate,'/download/questionnaire')"
          >
            <font-awesome-icon icon="file-pdf" />
          </b-button>

          <!-- <b-button
            class="ml-2"
            v-if="questionnaire.task_status == 4"
            variant="outline-primary"
            @click="getTaskForm(questionnaire.form_id,questionnaire.type,questionnaire.id,questionnaire.task_title)"
          >
            <font-awesome-icon icon="eye" />
          </b-button>-->
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import axios from "axios";
import config from "./../configs/config";
import AppLoader from "../components/Loader/Loader";
import { Helper } from "../helpers";
import { mapGetters, mapActions, mapMutations } from "vuex";
import moment from "moment";
import { HTTP } from "../utils/HTTP";
export default {
  name: "MyTPPQuestionannires",
  components: {
    AppLoader
  },

  data() {
    return {
      certifications: [],
      breadcrumbs: [
        {
          text: this.$t("dashboard"),
          href: "/onboarding/dashboard"
          // href: "/dashboard"
        },

        {
          text: this.$t("annual-certifications.title"),
          active: true
        }
      ]
    };
  },

  computed: {
    ...mapGetters({
      form: "form1",
      selectedLanguage: "selectedLanguage",
      isLoading: "isLoading"
    })
  },

  watch: {
    selectedLanguage(lang) {
      this.breadcrumbs = [
        {
          text: this.$t("dashboard"),
          href: "/onboarding/dashboard"
          // href: "/dashboard"
        },

        {
          text: this.$t("questionnaires.title"),
          active: true
        }
      ];
    }
  },

  mounted() {
    this.getTasks();
  },

  methods: {
    async getTasks() {
      let token = "Bearer " + localStorage.getItem("accessToken");
      let userId = localStorage.getItem("userId");
      try {
        let result = await HTTP(
          "post",
          "v1/mytpp/tasks",
          {
            userId: userId
          },

          {
            Authorization: token
          },
          null,
          true
        );
        this.certifications = result.data.certifications || [];
      } catch (error) {}
    },

    getFormTitle(form) {
      // // console.log("ff", ff)
      let formSchema = JSON.parse(form.schema || form.form_schema);
      // // console.log("gg", gg.formTitle[this.selectedLanguage])
      return formSchema.formTitle[this.selectedLanguage];
    },

    getTpTitle(form) {
      // // console.log("ff", ff)
      let formSchema = JSON.parse(form.schema || form.form_schema);
      // // console.log("gg", gg.formTitle[this.selectedLanguage])
      return formSchema.formTitle[this.selectedLanguage];
    },

    getTpCountry(form) {
      // // console.log("ff", ff)
      let formSchema = JSON.parse(form.schema || form.form_schema);
      // // console.log("gg", gg.formTitle[this.selectedLanguage])
      return formSchema.formTitle[this.selectedLanguage];
    },

    makeToast() {
      const h = this.$createElement;
      const vNodesMsg = h("p", { class: ["text-center", "mb-0"] }, [
        h("b-spinner", { props: { type: "grow", small: true } }),
        // " We are generating your PDF... ",
        this.$t("toast.generatePDF"),
        h("b-spinner", { props: { type: "grow", small: true } })
      ]);
      this.$bvToast.toast([vNodesMsg], {
        variant: "warning",
        title: "PDF",
        autoHideDelay: 5000
      });
    },

    async downloadPdf(questionnaire, route) {
      let formDefaultLanguage = localStorage.getItem("formDefaultLanguage");
      let taskId = questionnaire.id;
      let title = questionnaire.task_title + ".pdf";
      this.makeToast();
      axios({
        url: config.API_URL + "v1/mytpp" + route + "/" + taskId,
        method: "POST",
        responseType: "blob", // important
        headers: {
          Authorization: "Bearer " + localStorage.getItem("accessToken")
        },
        data: { formDefaultLanguage: formDefaultLanguage }
      })
        .then(response => {
          if (window.navigator.msSaveOrOpenBlob) {
            // let blob = response.data.blob;
            let blob = new Blob([response.data]);
            // IE11
            window.navigator.msSaveOrOpenBlob(blob, title);
            Helper.makeToast(
              this.$bvToast,
              "success",
              this.$t("toast.successPDF")

              // "PDF download successfully"
            );
            return;
          } else {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", title); //or any other extension
            document.body.appendChild(link);
            link.click();
            if (response) {
              Helper.makeToast(
                this.$bvToast,
                "success",
                this.$t("toast.successPDF")

                // "PDF download successfully"
              );
            }
          }
        })
        .catch(error => {
          Helper.makeToast(
            this.$bvToast,
            "danger",
            this.$t("toast.errorPDF")
            // "PDF not downloaded please try again"
          );
        });
    },

    getTaskFormType(value) {
      let type = "Questionniare";
      if (value == 2) {
        type = "Survey";
      } else if (value == 3) {
        type = "Training";
      } else if (value == 4) {
        type = "Exam";
      }
      return type;
    },

    getQuestionnaireStatusVariant(taskStatus) {
      if (taskStatus == 4) {
        return "success";
      } else if (taskStatus == 1) {
        return "warning";
      } else if (taskStatus == 0) {
        return "primary";
      }
      return "";
    },
    getQuestionnaireStatusText(taskStatus) {
      let status = "";
      if (taskStatus == 4) {
        status = this.$t("questionnaires.batchText");
      } else if (taskStatus == 1) {
        status = this.$t("questionnaires.batchInProgressText");
      } else if (taskStatus == 0) {
        status = this.$t("questionnaires.batchNotStartedext");
      }
      return status;
    },

    getQuestionnaireButtonLabel(taskStatus) {
      let status = "";

      if (taskStatus == 0) {
        status = this.$t("startBtnText");
      } else if (taskStatus == 1) {
        status = this.$t("continueBtnText");
      }
      return status;
    },

    age(value) {
      // // console.log(value);
      let localeData = moment.updateLocale("en", {
        relativeTime: {
          future: "in %s",
          past: "%s ago",
          s: "hello, a few seconds",
          ss: "%d seconds",
          m: "a minute",
          mm: "%d minutes",
          h: "an hour",
          hh: "%d hours",
          d: "a day",
          dd: "%d days",
          M: "a month",
          MM: "%d months",
          y: "a year",
          yy: "%d years"
        }
      });
      //return moment(value).fromNow();

      return moment(value).fromNow();
    },

    async getTaskForm(formId, formType, taskId, task_title) {
      localStorage.removeItem("taskId");
      localStorage.removeItem("activeFormId");
      localStorage.removeItem("activeFormSchema");
      localStorage.removeItem("taskFormData");
      localStorage.removeItem("activeTaskStatus");
      localStorage.setItem("taskId", taskId);
      localStorage.setItem("task_title", task_title);
      let userId = localStorage.getItem("userId");
      let token = "Bearer " + localStorage.getItem("accessToken");
      if (formType !== 1) {
        let result = await HTTP(
          "post",
          "v1/mytpp/task/" + taskId,
          {
            userId: userId,
            formType: formType
          },
          {
            Authorization: token
          },
          null,
          true
        );

        if (result.data.task && result.data.task) {
          // alert(result.data.task.task_status);
          let form = result.data.task.form.schema;
          let form_data = JSON.parse(result.data.task.form_data);
          // // console.log("result.data.task.form", form_data.user_data);

          if (form_data && form_data.hasOwnProperty("user_data")) {
            // // console.log("result.data.task.form", form_data.user_data);
            this.$store.state.getUserFormSubmitArray = form_data.user_data;
          }
          localStorage.setItem("activeFormSchema", form);
          localStorage.setItem(
            "activeTaskStatus",
            result.data.task.task_status
          );

          let newRoute = "";
          if (form_data && form_data.hasOwnProperty("user_consent")) {
            localStorage.setItem("userConsent", form_data.user_consent);
          } else {
            localStorage.setItem("userConsent", 0);
          }

          newRoute = "/user-form";
          //window.open("http://localhost:1090"+newRoute,'','postwindow');
          this.$router.push({
            path: newRoute,
            params: {
              from: "/mytpp"
            }
          });
        } else {
          this.$route.push("/user-form");
        }
      }
    }
  }
};
</script>

<style scoped>
</style>
